<template>
  <b-container fluid style="text-align:left;">
    <b-table width="100%" style="width:100%" :items="data" :fields="field">
      <template slot="value" slot-scope="d">
        {{
          d.item.option_value
            ? `${
                typeof d.item.option_value === "object" ||
                typeof d.item.option_value === "array"
                  ? d.item.option_value.join(", ")
                  : d.item.option_value
              }`
            : d.value
        }}
      </template>
    </b-table>
    <b-row v-if="data.length <= 0">
      <b-col>
        <span>ไม่มีผลข้อมูล</span>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import moment from "moment-timezone";
import format from "date-fns/format";

export default {
  name: "TestHistoryModalComponent",
  components: {},
  props: {
    data: {},
  },
  computed: {
    dataFilter() {
      return this.data.filter((d) => d.value && d.value != "");
    },
  },
  mounted() {},
  data() {
    return {
      field: [
        { key: "name", label: "ชื่อผลตรวจ" },
        { key: "value", label: "ค่าผลตรวจ" },
        { key: "order_date", label: "วันที่ตรวจ" },
      ],
    };
  },
  watch: {},
  methods: {},
};
</script>

<style scoped>
.header-input {
  width: 10rem;
}
</style>

<style>
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #fb822b;
  background-color: #fb822b;
}
.custom-checkbox
  .custom-control-input:indeterminate
  ~ .custom-control-label::before {
  border-color: #fb822b;
  background-color: #fb822b;
}
</style>
